<style scoped>
    .confirm-message {
        text-align: center;
    }
</style>

<template>
<ValidationObserver ref="observer" v-slot="{ invalid }">
    <v-dialog v-model="handleDialog" width="700" class="common-dialog">
        <v-card color="#F4FEFB">
            <v-card-title class="justify-center text-h5">企業印影</v-card-title>
                <v-card-text
                    class="common-dialog-message"
                >
                <v-container>
                    <v-row>
                        <v-img
                            :src="selectSealData"
                            max-height="300"
                            max-width="300"
                            width="300"
                            height="300"
                            :contain="true"
                        >
                        </v-img>
                        <seal-upload-component
                            @selectSeal="selectSeal"
                            @imprintName = "imprintName"
                        ></seal-upload-component>
                        <v-card-title>
                            <badge-component tile content="必　須" color="red">
                                <label-component>印影名</label-component>
                            </badge-component>  
                        </v-card-title>
                        <v-card-text
                            class="common-dialog-message"
                        >
                        <v-col cols="12" xl="12">
                             <ValidationProvider rules="required|max:255" v-slot="{ errors }">
                                <v-text-field outlined clearable v-disabled-icon-focus v-model="imprint_name" :error-messages="errors" background-color="white"></v-text-field>
                            </ValidationProvider>                            
                        </v-col>
                    </v-card-text>
                    </v-row>
                </v-container>
            </v-card-text>
            
            <v-divider></v-divider>
            
            <v-card-actions class="justify-center grey lighten-4 pb-6">
                <v-btn min-width="150px" class="white--text" color="blue-grey lighten-1" large @click="handleDialog = false">
                    <slot name="cancel-btn"></slot>
                </v-btn>
                <v-btn min-width="150px" class="white--text" color="red" large v-on:click="add" :disabled="!isValid">
                    <slot name="ok-btn"></slot>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</ValidationObserver>
</template>

<script>
export default {
    data() {
        return {
            selectDestinations: [],
            selectSealData: '',
            imprint_name: '',
        };
    },
    props: {
        // ダイアログの開閉
        addDialog: Boolean,
    },
        created: function () {
    },
    computed: {
        handleDialog: {
            get() {
                return this.addDialog;
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('update:addDialog', value);
            }
        },
        isValid: {
            get() {
                if (this.selectSealData == '' || this.selectSealData == null ||  this.imprint_name == '' || this.imprint_name == null) {
                    return false;
                }
                return true;
            },
            set(value) {
                
            }
        }        
    },
    methods: {
        add: function (event) {
            axios.post(
                '/documents/add-company-electronic-imprints',
                {
                    'selectSealData': this.selectSealData,
                    'imprint_name': this.imprint_name
                }
            ).then(res => {
                // 親コンポーネントへの通知
                if (res.data['success']) {
                    this.$emit("success", res.data.message);
                    this.handleDialog = false;
                } else {
                    this.$emit("error", res.data.message);
                }
            }).catch(res => {
                this.success = false;
                this.message = "処理に失敗しました";                 
            }).finally(() => {
            });
        },
        selectSeal: function (sealData) {
            this.selectSealData = sealData;
        },
        imprintName: function (sealData) {
            this.imprint_name = sealData.substring(0, sealData.lastIndexOf('.'));
        }
    },
};
</script>